import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { MetricDefinitionRecord } from "../MetricRecord";

import { metricsQueryKeys } from "./metricsQueryKeys";

/**
 * Returns ALL metric definitions as a flat array, draining pagination
 * internally. Use for small bounded sets (a few hundred).
 */
export function useAllMetricDefinitions(orgId: string | undefined) {
  const { metricsService } = useDomainServices();

  return useQuery<MetricDefinitionRecord[], Error>({
    queryKey: metricsQueryKeys.definitionsAll(orgId),
    queryFn: ({ signal }) =>
      metricsService.getAllMetricDefinitions({
        abortSignal: signal,
        orgId,
      }),
    enabled: orgId !== undefined,
    staleTime: 60_000,
  });
}
